module.exports = __webpack_public_path__ + "img/TeslaArmor.13dc781a.gif";